<template>
    <button
        :class="buttonClasses"
        :type="nativeType"
        :disabled="disabled"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: "BaseButton",
    props: {
        type: {
            type: String,
            default: "default", // 'default', 'primary', 'secondary', etc.
        },
        nativeType: {
            type: String,
            default: "button", // 'button', 'submit', 'reset'
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: false, // Tombol lebar penuh
        },
        rounded: {
            type: Boolean,
            default: true, // Tombol dengan border radius
        },
    },
    computed: {
        buttonClasses() {
            return [
                "inline-flex items-center justify-center font-medium focus:outline-none transition duration-150 ease-in-out",
                this.fullWidth ? "w-full" : "px-4 py-2",
                this.rounded ? "rounded-lg" : "",
                this.disabled ? "bg-gray-300 text-gray-500 cursor-not-allowed" : this.getTypeClasses,
            ];
        },
        getTypeClasses() {
            switch (this.type) {
                case "primary":
                    return "bg-blue-500 text-white hover:bg-blue-600";
                case "secondary":
                    return "bg-transparent border border-blue-500 text-blue-500 hover:bg-blue-100";
                case "basic":
                    return "bg-transparent text-gray-500";
                case "success":
                    return "bg-green-500 text-white hover:bg-green-600";
                case "danger":
                    return "bg-red-500 text-white hover:bg-red-600";
                case "warning":
                    return "bg-yellow-500 text-white hover:bg-yellow-600";
                default:
                    return "bg-gray-200 text-gray-800 hover:bg-gray-300";
            }
        },
    },
    // methods: {
    //     handleClick(event) {
    //         console.log("Button clicked!", event); // Debug log
    //         this.$emit("click", event);
    //     },
    // },
};
</script>